import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, StaticContext, useHistory } from "react-router";
import AccessoryCard from "src/components/Accessories/Blocks/DrawerCard";
import DoneButton from "src/components/Accessories/Elements/DoneButton";
import Loading from "src/components/Accessories/Elements/Loading";
import NoResults from "src/components/Accessories/Elements/NoResults";
import { ApplicationStore } from "src/store";
import { getAccessoriesRequest } from "src/store/actions/accessories";
import { getSelectedPaymentType, getVehicle } from "src/store/selectors/vehicles";
import "src/components/Accessories/accessories.scss";
import DrawerWrapper from "src/components/MyGarage/DrawerWrapper/Blocks/DrawerWrapper";
import { analyticsFEA } from "src/AnalyticsFEA";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer";

type RouteProps = RouteComponentProps<{}, StaticContext, { vin: string }>;

export const DrawerView = ({
    vehicle,
    uuid,
    title,
    paymentType,
    loading,
    hasAccessories,
    accessories = [],
    getAccessories,
    toggleDrawer,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    useEffect(() => {
        getAccessories(uuid, vehicle.vin, paymentType);
    }, [getAccessories, paymentType, uuid, vehicle.vin]);

    const history = useHistory();

    const handleClick = () => {
        toggleDrawer();
        analyticsFEA.engine.FAndIFinish(uuid, [vehicle]);
        history.push("/my-garage", { vin: vehicle.vin });
    };

    return (
        <DrawerWrapper title={title} vin={vehicle.vin}>
            {hasAccessories ? (
                accessories.map((id) => (
                    <AccessoryCard key={`${vehicle.vin}:${id}`} vin={vehicle.vin} accessoryId={id} />
                ))
            ) : loading ? (
                <Loading />
            ) : (
                <NoResults />
            )}

            <DoneButton handleClick={handleClick} />
        </DrawerWrapper>
    );
};

const mapStateToProps = (
    state: ApplicationStore,
    {
        location: {
            state: { vin },
        },
    }: RouteProps
) => ({
    uuid: state.deal.uuid!,
    paymentType: getSelectedPaymentType(state, vin),
    loading: state.accessories?.[vin]?.isLoading,
    hasAccessories: !!state.accessories?.[vin]?.available?.[getSelectedPaymentType(state, vin)]?.length,
    accessories: state.accessories?.[vin]?.available?.[getSelectedPaymentType(state, vin)],
    title: state.account?.account_disclaimers?.upgrades_label,
    vehicle: getVehicle(state, vin),
});

const mapDispatchToProps = {
    getAccessories: getAccessoriesRequest,
    toggleDrawer: toggleGarageDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerView);
